module.exports = __webpack_public_path__ + "img/deletes.150dc8e6.svg";